"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.axiosErrorStatusSelector = exports.resolveRequestError = exports.axiosErrorHandler = void 0;
var errors_1 = require("../types/errors");
var axiosErrorHandler = function (callback) {
    return function (error) {
        if (error.isAxiosError) {
            callback({
                error: error,
                type: errors_1.ErrorTypes.REQUEST,
            });
        }
        else {
            callback({
                error: error,
                type: errors_1.ErrorTypes.TYPE_ERROR,
            });
        }
    };
};
exports.axiosErrorHandler = axiosErrorHandler;
var resolveRequestError = function (error) { var _a, _b; return (_b = (_a = error === null || error === void 0 ? void 0 : error.error) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data; };
exports.resolveRequestError = resolveRequestError;
var axiosErrorStatusSelector = function (error) { var _a, _b; return (_b = (_a = error === null || error === void 0 ? void 0 : error.error) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.status; };
exports.axiosErrorStatusSelector = axiosErrorStatusSelector;
